import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(private http: HttpClient) { }

  createClient(payload: any) {
    return this.http.post(`${environment.apiUrl}/client/create`, payload);
  }

  getPagedClients(payload: {
    pageIndex: number;
    pageSize: number;
    filters: any;
    sortField?: string;
    sortOrder?: number;
  }) {
    const requestPayload = {
      ...payload,
    };
    return this.http.post(
      `${environment.apiUrl}/client/get-paged`,requestPayload
    );
  }

  updateClient(payload: any) {
    return this.http.put(`${environment.apiUrl}/client/update`, payload);
  }

  getOneClientById(id: string) {
    return this.http.get(`${environment.apiUrl}/client/get-one/${id}`);
  }

  getAllClients() {
    return this.http.get(`${environment.apiUrl}/client/get-all`);
  }

  changePassword(payload: { id: string; oldPassword: string; password: string }) {
    return this.http.post(`${environment.apiUrl}/client/change-password`, payload);
  }

  getPagedExpiredClients(payload: {
    pageIndex: number;
    pageSize: number;
    filters: any;
    sortField?: string;
    sortOrder?: number;
  }) {
    const requestPayload = {
      ...payload,
    };
    return this.http.post(
      `${environment.apiUrl}/client/get-paged-expired`, requestPayload
    );
  }

  getIdSuggestion(clientType: string) {
    return this.http.get(
      `${environment.apiUrl}/client/id-suggestion/${encodeURIComponent(clientType)}`,
    );
  }

  prepareClientTypeChange(clientId: string, targetType: string) {
    return this.http.post<{ success: boolean; data: any; message?: string }>(
      `${environment.apiUrl}/client/prepare-type-change`,
      { clientId, targetType },
    );
  }

  renewClient(
    clientId: string,
    payload: { renewalDate: string; fee: number; notes?: string },
  ) {
    return this.http.post<{ success: boolean; data: any; message?: string }>(
      `${environment.apiUrl}/client/${clientId}/renew`,
      payload,
    );
  }

  updateRenewalRecord(
    clientId: string,
    renewalId: string,
    payload: { renewalDate: string; fee: number; notes?: string },
  ) {
    return this.http.put<{ success: boolean; data: any; message?: string }>(
      `${environment.apiUrl}/client/${clientId}/renewal/${renewalId}`,
      payload,
    );
  }
}
